(function () {
  const wrappers = ['.social-share-container', '.mh-card-buttons-component'];

  document.addEventListener('keydown', function (event) {
    if (event.key === ' ' || event.code === 'Space') {
      const target =
        (typeof event.composedPath === 'function' &&
          event.composedPath().find((el) => el instanceof Element && el.tagName === 'A')) ||
        event.target;
      if (
        target.tagName === 'A' &&
        (target.classList.contains('btn-link') ||
          target.classList.contains('btn') ||
          wrappers.some((selector) => target.closest(selector)))
      ) {
        event.preventDefault();
        target.click();
      }
    }
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  const collapseElementList = [].slice.call(document.querySelectorAll('.card-buttons-component-collapse'));

  collapseElementList.forEach(function (collapseEl) {
    collapseEl.addEventListener('shown.bs.collapse', function () {
      const collapseButton = collapseEl.closest('.mh-card-buttons-component').querySelector('.card-buttons-collapse');
      collapseButton.innerHTML = collapseButton.dataset.collapseLabel;
    });

    collapseEl.addEventListener('hidden.bs.collapse', function () {
      const collapseButton = collapseEl.closest('.mh-card-buttons-component').querySelector('.card-buttons-collapse');
      collapseButton.innerHTML = collapseButton.dataset.expandLabel;
    });
  });
});
